import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Norex International Trading Ltd. respects the privacy of every visitor, buyer, and supplier who contacts us through this website.",
      "Information you submit through our Request for Quotation and supplier application forms — including your name, company, contact details, and product requirements — is used solely to respond to your enquiry, evaluate supply options, and conduct legitimate business communication.",
      "We do not sell, rent, or share your personal or business information with third parties except where necessary to facilitate a transaction you have requested (for example, presenting your product requirements to a potential supplier), or where required by law.",
      "Documents uploaded through our forms are stored securely and accessed only by authorized members of our sourcing team.",
      "You may request correction or deletion of your submitted information at any time by emailing norexinternationaltradingltd@gmail.com.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "This website is operated by Norex International Trading Ltd. ('Norex', 'we', 'us'). By using this website you accept these terms.",
      "Content on this website is provided for general information about our sourcing, procurement, trading, import, export, distribution, and supply services. It does not constitute a binding offer, quotation, or contract.",
      "Any business transaction with Norex is governed by a separately negotiated and signed contract specifying product, specifications, quantities, pricing, delivery terms, and payment terms.",
      "Submitting an RFQ or supplier application through this website does not create a contractual obligation for either party.",
      "We may update website content and these terms at any time without prior notice.",
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    body: [
      "The information on this website is provided in good faith and for general guidance only. Norex International Trading Ltd. makes no representation or warranty of any kind regarding the completeness or accuracy of website content.",
      "Product availability, specifications, and pricing are always subject to confirmation at the time of a formal transaction.",
      "Norex International Trading Ltd. acts as a sourcing, procurement, trading, and supply facilitation company. Specific regulatory, licensing, or compliance requirements applicable to any commodity or destination remain the responsibility of the contracting parties as defined in individual agreements.",
      "For any questions regarding this disclaimer, contact norexinternationaltradingltd@gmail.com.",
    ],
  },
};

export default function LegalPage() {
  const { doc } = useParams();
  const page = CONTENT[doc] || CONTENT.privacy;

  return (
    <div data-testid="legal-page" className="min-h-screen bg-midnight">
      <div className="max-w-3xl mx-auto px-6 py-24">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-sm text-[#94A3B8] hover:text-gold transition-colors duration-200 mb-12"
        >
          <ArrowLeft className="w-4 h-4" /> Back to website
        </Link>
        <p className="text-xs uppercase tracking-[0.25em] text-gold mb-4">Legal</p>
        <h1 className="text-3xl md:text-4xl tracking-tight font-bold text-[#F4F6F8] mb-10" data-testid="legal-title">
          {page.title}
        </h1>
        <div className="space-y-6">
          {page.body.map((p, i) => (
            <p key={i} className="text-base text-[#94A3B8] leading-relaxed">
              {p}
            </p>
          ))}
        </div>
        <p className="mt-16 text-xs text-[#94A3B8]/60">
          © 2026 Norex International Trading Ltd. All Rights Reserved.
        </p>
      </div>
    </div>
  );
}
